<template>
  <card-item
    card="item_trade_in_info"
    :tabs="tabs"
    :disableId="true"
    v-model="activeTab"
    :id="`${id}${
      $store.state.user.sections['report_trade_ins'] ||
      $store.state.user.sections['scan_trade_ins']
        ? ''
        : '000030003'
    }`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "",
          key: "info",
          component: () => import("./Info"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>